/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getWatchListingUserInfo = /* GraphQL */ `
  query GetWatchListingUserInfo($id: ID!) {
    getWatchListingUserInfo(id: $id) {
      id
      watchListing {
        id
        type
        title
        body
        url
        datetime
        sold
        thumbnail
        link_flair_text
        author_flair_text
        author
        created_timestamp
        price
        ttl
        createdAt
        updatedAt
      }
      userInfo {
        id
        collector
        email
        emailAcknowledged
        phone
        phoneAcknowledged
        phoneValidated
        phoneValidationCode
        stripe_customer
        weeklyTextCount
        weeklyEmailCount
        createdAt
        updatedAt
        owner
      }
      sim
      brand
      description
      notifyEmail
      notifyPhone
      subscriptionID
      ttl
      link_flair_text
      author
      author_flair_text
      postTitle
      createdAt
      updatedAt
      watchListingUserInfoWatchListingId
      watchListingUserInfoUserInfoId
    }
  }
`;
export const listWatchListingUserInfos = /* GraphQL */ `
  query ListWatchListingUserInfos(
    $filter: ModelWatchListingUserInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWatchListingUserInfos(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        sim
        brand
        description
        notifyEmail
        notifyPhone
        subscriptionID
        ttl
        link_flair_text
        author
        author_flair_text
        postTitle
        createdAt
        updatedAt
        watchListingUserInfoWatchListingId
        watchListingUserInfoUserInfoId
      }
      nextToken
    }
  }
`;
export const getUserWatchSubscriptionInfo = /* GraphQL */ `
  query GetUserWatchSubscriptionInfo($id: ID!) {
    getUserWatchSubscriptionInfo(id: $id) {
      id
      brand
      description
      expiration
      expiration_datetime
      userinfoID
      notifyEmail
      notifyPhone
      searchField
      ttl
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listUserWatchSubscriptionInfos = /* GraphQL */ `
  query ListUserWatchSubscriptionInfos(
    $filter: ModelUserWatchSubscriptionInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserWatchSubscriptionInfos(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        brand
        description
        expiration
        expiration_datetime
        userinfoID
        notifyEmail
        notifyPhone
        searchField
        ttl
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const userWatchSubscriptionInfosByUserinfoID = /* GraphQL */ `
  query UserWatchSubscriptionInfosByUserinfoID(
    $userinfoID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserWatchSubscriptionInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userWatchSubscriptionInfosByUserinfoID(
      userinfoID: $userinfoID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        brand
        description
        expiration
        expiration_datetime
        userinfoID
        notifyEmail
        notifyPhone
        searchField
        ttl
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getWatchListing = /* GraphQL */ `
  query GetWatchListing($id: ID!) {
    getWatchListing(id: $id) {
      id
      type
      title
      body
      url
      datetime
      sold
      thumbnail
      link_flair_text
      author_flair_text
      author
      created_timestamp
      price
      ttl
      createdAt
      updatedAt
    }
  }
`;
export const listWatchListings = /* GraphQL */ `
  query ListWatchListings(
    $filter: ModelWatchListingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWatchListings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        title
        body
        url
        datetime
        sold
        thumbnail
        link_flair_text
        author_flair_text
        author
        created_timestamp
        price
        ttl
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listWatchListingsByDate = /* GraphQL */ `
  query ListWatchListingsByDate(
    $type: String!
    $created_timestamp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWatchListingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWatchListingsByDate(
      type: $type
      created_timestamp: $created_timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        title
        body
        url
        datetime
        sold
        thumbnail
        link_flair_text
        author_flair_text
        author
        created_timestamp
        price
        ttl
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserInfo = /* GraphQL */ `
  query GetUserInfo($id: ID!) {
    getUserInfo(id: $id) {
      id
      collector
      email
      emailAcknowledged
      phone
      phoneAcknowledged
      phoneValidated
      phoneValidationCode
      Subscriptions {
        nextToken
      }
      stripe_customer
      weeklyTextCount
      weeklyEmailCount
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listUserInfos = /* GraphQL */ `
  query ListUserInfos(
    $filter: ModelUserInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserInfos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        collector
        email
        emailAcknowledged
        phone
        phoneAcknowledged
        phoneValidated
        phoneValidationCode
        stripe_customer
        weeklyTextCount
        weeklyEmailCount
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getAppInfo = /* GraphQL */ `
  query GetAppInfo($id: ID!) {
    getAppInfo(id: $id) {
      notificationCount
      id
      createdAt
      updatedAt
    }
  }
`;
export const listAppInfos = /* GraphQL */ `
  query ListAppInfos(
    $filter: ModelAppInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAppInfos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        notificationCount
        id
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
